import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
}

firebase.initializeApp(firebaseConfig)

// utils
const auth = firebase.auth()

const firestore = firebase.firestore()
  .enablePersistence({synchronizeTabs: true})
  .then(() => firebase.firestore())

const firestoreConstructors = firebase.firestore

const storage = firebase.storage()

let userLoaded = false
/**
 * Retrieves the currently authenticated user. If the user data has not been loaded yet,
 * it waits for the user's authentication state to change before resolving the promise.
 * @returns {Promise<Object|null>} A promise that resolves to the currently authenticated user or null if no user is authenticated.
 */
function getAuthCurrentUser () {
  return new Promise((resolve, reject) => {
    if (userLoaded) {
      resolve(auth.currentUser)
    } else {
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true
        unsubscribe()
        resolve(user)
      }, reject)
    }
  })
}

export {
  auth,
  firestore,
  firestoreConstructors,
  storage,
  getAuthCurrentUser
}



// WEBPACK FOOTER //
// ./src/plugins/firebase.js